import axiosInstance from './AxiosInstance';

/**
 * CompanyService - Handles company-related API calls
 */
const CompanyService = {
  /**
   * Get company details for the current user context (role-based)
   * @returns {Promise<Object>} Company details response
   */
  getCompanyDetails: async () => {
    try {
      const token = localStorage.getItem('accessToken');
      const response = await axiosInstance.get('/companies/details', {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
      return response.data;
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message || 'Failed to fetch company details';
      throw {
        message: errorMessage,
        status: error.response?.status,
      };
    }
  },

  /**
   * Convert DB file path (with appData/) to public API URL
   * @param {string} dbPath - Path from DB (e.g., "appData/companies/logos/file.png")
   * @returns {string|null} API URL for file access
   */
  getFileUrl: (dbPath) => {
    if (!dbPath) return null;
    return `${(process.env.REACT_APP_BASE_URL || 'http://localhost:8080/api')}/company-uploads/${dbPath.replace('appData/', '')}`;
  },

  getCompanyLoginLogoUrl: (websiteName) => {
    let dataMain = `${(process.env.REACT_APP_BASE_URL || 'http://localhost:8080/api')}/company-uploads/company-logo?website=${websiteName}`;
    return dataMain;
  },
  
  /**
   * Update PWA related details for a company (backend should expose this endpoint)
   * @param {string} website - company website identifier
   * @param {Object} pwaData - PWA configuration payload (manifest fields, icons, theme_color, etc.)
   */
  updatePwaDetails: async (website, pwaData) => {
    try {
      const response = await axiosInstance.post(`/companies/pwa/${website}`, pwaData);
      return response.data;
    } catch (error) {
      const message = error.response?.data?.message || error.message || 'Failed to update PWA details';
      throw { message, status: error.response?.status };
    }
  }
};

export default CompanyService;
